let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j7BLQ")).then(() => parcelRequire('aP1uq'));